import PageTabs from "../../../../components/Common/PageTabs";
import HolidaysTab from "./HolidaysTab";
import ClosedMessagesTab from "./ClosedMessagesTab";
import HoursOfOperationsOverwritesTab from "./HoursOfOperationsOverwritesTab";
import CallbacksTab from "./CallbacksTab";

const QueueDetailsTabs = ({ queue, setFormEdited, isLoading, setIsLoading }) => {
	const tabs = [
		{
			label: "Closed Messages",
			id: "closedMessages",
			component: <ClosedMessagesTab isLoading={isLoading} setIsLoading={setIsLoading} queue={queue} />,
			default: true,
			tooltip:
				"Allows to play unique prompts within configurable times to any callers who call when the contact center is either closing soon or already closed.",
		},
		{
			label: "Hour Overwrites",
			id: "hourOverwrites",
			component: <HoursOfOperationsOverwritesTab setIsLoading={setIsLoading} queue={queue} />,
			default: false,
			tooltip:
				"Allow you to quickly create one-off overwrites to your Amazon Connect queues and their designated hours of operation calendars, which is ideal for handling business hour changes due to company-wide meetings, inclement weather, and other special events.",
		},
		{
			label: "Holidays",
			id: "holidays",
			component: <HolidaysTab setIsLoading={setIsLoading} queue={queue} />,
			default: false,
			tooltip:
				"Allows to create holidays for your contact center. Your contact center will remain closed during any holidays you create.",
		},
		{
			label: "Callbacks",
			id: "callbacks",
			component: <CallbacksTab setIsLoading={setIsLoading} queue={queue} />,
			default: false,
			tooltip:
				"Allows you to configure callbacks for this queue. You can enable callbacks so calling customers can request one when agents are not available.",
		},
	];
	return <PageTabs tabs={tabs.filter((t) => !t.hidden)} requireConfirmOnChange onTabContentModified={setFormEdited} />;
};

export default QueueDetailsTabs;
